module.exports = "pegasus/assets/blocks/column-lp2-themelp1.png";